export const dataUrlToBlob = (dataUrl: string): Blob => {
    const [meta, b64] = dataUrl.split(',')
    const mime = meta.match(/data:(.*?);base64/)?.[1] ?? 'image/jpeg'
    const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0))
    return new Blob([bytes], { type: mime })
}

export function updateAtIndex<T>(items: T[], index: number, value: T): T[] {
    const next = [...items]
    next[index] = value
    return next
}

export function renameFile(file: File, index: number): File {
    const extension = file.name.split('.').pop()
    const fileName = extension ? `img${index}.${extension}` : `img${index}`
    return new File([file], fileName, { type: file.type })
}

export function renameFilesSequentially(files: File[]): File[] {
    return files.map((file, index) => renameFile(file, index + 1))
}
